import { BillStatus } from '@/modules/finance/bills/types/bills';
import { BillStatusDTO } from '@/modules/finance/bills/types/dto/bill-status.dto';

/**
 * Maps BillStatusDTO from API to domain BillStatus enum
 */
export const mapBillStatusFromDTO = (dto: BillStatusDTO): BillStatus => {
  switch (dto) {
    case BillStatusDTO.IN_PROGRESS:
      return BillStatus.InProgress;
    case BillStatusDTO.OPEN:
      return BillStatus.Open;
    case BillStatusDTO.PAID:
      return BillStatus.Paid;
    case BillStatusDTO.OVERDUE:
      return BillStatus.Overdue;
    case BillStatusDTO.ERROR:
      return BillStatus.Error;
    default:
      return BillStatus.Unknown;
  }
};

/**
 * Maps domain BillStatus enum to BillStatusDTO for API requests
 */
export const mapBillStatusToDTO = (status: BillStatus): BillStatusDTO => {
  switch (status) {
    case BillStatus.InProgress:
      return BillStatusDTO.IN_PROGRESS;
    case BillStatus.Open:
      return BillStatusDTO.OPEN;
    case BillStatus.Paid:
      return BillStatusDTO.PAID;
    case BillStatus.Overdue:
      return BillStatusDTO.OVERDUE;
    case BillStatus.Error:
      return BillStatusDTO.ERROR;
    case BillStatus.Unknown:
    default:
      throw new Error(`Cannot map unknown bill status to DTO: ${status}`);
  }
};
